import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import {
  BookOpen,
  Sparkles,
  CalendarDays,
  Trophy,
  Target,
  Newspaper,
  Languages,
  Flame,
} from "lucide-react";

const ICONS = [
  { Icon: BookOpen, color: "from-blue-100 to-blue-50", iconColor: "text-blue-900" },
  { Icon: Sparkles, color: "from-amber-100 to-amber-50", iconColor: "text-amber-600" },
  { Icon: CalendarDays, color: "from-emerald-100 to-emerald-50", iconColor: "text-emerald-700" },
  { Icon: Trophy, color: "from-red-100 to-red-50", iconColor: "text-red-700" },
  { Icon: Target, color: "from-purple-100 to-purple-50", iconColor: "text-purple-700" },
  { Icon: Newspaper, color: "from-orange-100 to-orange-50", iconColor: "text-orange-700" },
  { Icon: Languages, color: "from-teal-100 to-teal-50", iconColor: "text-teal-700" },
  { Icon: Flame, color: "from-pink-100 to-pink-50", iconColor: "text-pink-700" },
];

const Features = () => {
  const { t } = useLanguage();
  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative py-24 sm:py-28"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="max-w-3xl">
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-amber-600">
            {t.features.eyebrow}
          </span>
          <h2
            data-testid="features-title"
            className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-blue-950 leading-[1.05]"
          >
            {t.features.title}
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
            {t.features.subtitle}
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.features.items.map((it, i) => {
            const { Icon, color, iconColor } = ICONS[i % ICONS.length];
            const big = i === 0 || i === 5;
            return (
              <div
                key={it.title}
                data-testid={`feature-card-${i}`}
                className={`card-lift bg-white border border-blue-900/10 rounded-2xl p-6 ${
                  big ? "lg:col-span-2" : ""
                }`}
              >
                <div
                  className={`h-12 w-12 rounded-xl bg-gradient-to-br ${color} flex items-center justify-center`}
                >
                  <Icon className={`${iconColor}`} size={22} strokeWidth={2.2} />
                </div>
                <h3 className="mt-4 text-lg sm:text-xl font-bold text-blue-950 tracking-tight">
                  {it.title}
                </h3>
                <p className="mt-2 text-sm sm:text-base text-slate-600 leading-relaxed">
                  {it.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
